import { call, put, select, takeEvery } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'
import getSalesman from '../../services/salesman/getSalesman'
import { fetchCombosSuccess } from '../../actions/combos/combos'

export function * fetchSalesman ({ organizedUnitId }) {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const salesmanCombo = yield call(getSalesman, organizedUnitId, auth.token)
    yield put(fetchCombosSuccess({ salesmanCombo }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchSalesman () {
  yield takeEvery(combosActionTypes.FETCH_SALESMAN, fetchSalesman)
}
